import { CustomerState } from '../../models/loyalty/customer.state';
import {
  CustomerActions,
  GET_CUSTOMER,
  GET_CUSTOMER_ERROR,
  GET_CUSTOMER_SUCCESS
} from '../../actions/loyalty/actions-customer';

/* eslint-disable */
function getInitialState(): CustomerState {
  return {
    isLoading: false,
    loadingError: ''
  } as CustomerState;
}

const initialState: CustomerState = getInitialState();

/* eslint-disable */
export function reducersCustomer(state = initialState, action: CustomerActions): CustomerState {
  switch (action.type) {
    case GET_CUSTOMER:
      return { ...state, isLoading: true, loadingError: '' };
    case GET_CUSTOMER_SUCCESS:
      return { ...action.payload, isLoading: false, loadingError: '' };
    case GET_CUSTOMER_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };
    default:
      return state;
  }
}
